/**
 * Syncs authenticated user to PostHog for identity tracking.
 * Identifies user on login/app load and resets on logout (including token expiry, manual clear).
 * Registers environment (local, qa, prod) as a super property on all events.
 */

import { usePostHog } from '@posthog/react';
import { useEffect } from 'react';

import { getAnalyticsEnvironment } from '@/lib/analytics';

import { useAuth } from './hooks';

export function PostHogIdentify() {
  const posthog = usePostHog();
  const { user, isAuthenticated } = useAuth();
  const environment = getAnalyticsEnvironment();

  useEffect(() => {
    if (!posthog) return;

    posthog.register({ environment });

    if (!isAuthenticated) {
      posthog.reset();
      return;
    }

    if (user) {
      posthog.identify(user.userId, {
        email: user.email,
        name: user.name,
        tenantId: user.tenantId,
        environment,
      });
    }
  }, [posthog, isAuthenticated, user, environment]);

  return null;
}
